import $ from 'jquery';
import config from './../../../config';

// Save Company
export function save_company( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'company/',
			data: {
                method: 'SAVE_COMPANY',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_COMPANY",
				company: response
			})
		})

	}
}

// Get Company
export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'company/',
			data: {
                method: 'GET_COMPANY'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_COMPANY",
				company: response
			})
		})

	}
}

// Delete Company
export function delete_company( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'company/',
			data: {
				method: 'DELETE_COMPANY',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_COMPANY",
				company: response
			})
		})

	}
}

// Get By ID Company
export function get_company_by_id( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'company/',
			data: {
				method: 'GET_BY_ID_COMPANY',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_BY_ID_COMPANY",
				company: response
			})
		})

	}
}


// Edit Company
export function edit_company( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'company/',
			data: {
				method: 'EDIT_COMPANY',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "EDIT_COMPANY",
				company: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/company/actions/company.action.js